import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('mesInfmStore', Object.keys(getters)),
	...mapState('mesInfmStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('mesInfmStore', Object.keys(actions)),
	...mapMutations('mesInfmStore', Object.keys(mutations))
};
